import { useProviderProps } from "@react-spectrum/provider";
import { useMessageFormatter } from "@react-aria/i18n";
import _react from "react";
import { filterDOMProps, mergeProps } from "@react-aria/utils";
import { classNames, useDOMRef, useStyleProps } from "@react-spectrum/utils";
import _spectrumIconsUiAsterisk from "@spectrum-icons/ui/Asterisk";
import _babelRuntimeHelpersEsmInteropRequireDefault from "@babel/runtime/helpers/esm/interopRequireDefault";
import _babelRuntimeHelpersEsmObjectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _babelRuntimeHelpersEsmExtends from "@babel/runtime/helpers/esm/extends";
import "./main.css";

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

// ASSET: /Users/govett/dev/react-spectrum-v3/node_modules/@adobe/spectrum-css-temp/components/fieldlabel/vars.css
var $c9fb1f4220ea2c59cb2e10f0e9828c6e$exports = {};
$c9fb1f4220ea2c59cb2e10f0e9828c6e$exports = {
  "spectrum-FieldLabel": "_spectrum-FieldLabel_36b9b",
  "spectrum-FieldLabel--positionSide": "_spectrum-FieldLabel--positionSide_36b9b",
  "spectrum-FieldLabel-requiredIcon": "_spectrum-FieldLabel-requiredIcon_36b9b",
  "spectrum-FieldLabel--alignEnd": "_spectrum-FieldLabel--alignEnd_36b9b",
  "spectrum-Field": "_spectrum-Field_36b9b",
  "spectrum-Field--positionTop": "_spectrum-Field--positionTop_36b9b",
  "spectrum-Field-field": "_spectrum-Field-field_36b9b",
  "spectrum-Field-field--multiline": "_spectrum-Field-field--multiline_36b9b",
  "spectrum-Field--positionSide": "_spectrum-Field--positionSide_36b9b",
  "spectrum-Form": "_spectrum-Form_36b9b",
  "spectrum-Form--positionSide": "_spectrum-Form--positionSide_36b9b",
  "spectrum-Form--positionTop": "_spectrum-Form--positionTop_36b9b",
  "spectrum-Form-itemLabel": "_spectrum-Form-itemLabel_36b9b",
  "is-disabled": "_is-disabled_36b9b"
};
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/label/intl/ar-AE.json
var $ad45dfef9011e4c5f6793c02ff0012ba$exports = {};
$ad45dfef9011e4c5f6793c02ff0012ba$exports = JSON.parse("{\"(optional)\":\"(اختياري)\",\"(required)\":\"(مطلوب)\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/label/intl/bg-BG.json
var $bc9346d18637648fe979bbfd1a0692b$exports = {};
$bc9346d18637648fe979bbfd1a0692b$exports = JSON.parse("{\"(optional)\":\"(optional)\",\"(required)\":\"(required)\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/label/intl/cs-CZ.json
var $cf801b2772a36c48aa537186890ce75$exports = {};
$cf801b2772a36c48aa537186890ce75$exports = JSON.parse("{\"(optional)\":\"(volitelně)\",\"(required)\":\"(požadováno)\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/label/intl/da-DK.json
var $f76ee2cdbe534525d5d381f977f1173$exports = {};
$f76ee2cdbe534525d5d381f977f1173$exports = JSON.parse("{\"(optional)\":\"(valgfrit)\",\"(required)\":\"(påkrævet)\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/label/intl/de-DE.json
var $d30e8bad1c352458524b55d6d74$exports = {};
$d30e8bad1c352458524b55d6d74$exports = JSON.parse("{\"(optional)\":\"(optional)\",\"(required)\":\"(erforderlich)\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/label/intl/el-GR.json
var $caa3858972ee8679426e788e7789e53b$exports = {};
$caa3858972ee8679426e788e7789e53b$exports = JSON.parse("{\"(optional)\":\"(προαιρετικό)\",\"(required)\":\"(απαιτείται)\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/label/intl/en-US.json
var $d52cb80a7ce3407593566f9943d0acc1$exports = {};
$d52cb80a7ce3407593566f9943d0acc1$exports = JSON.parse("{\"(required)\":\"(required)\",\"(optional)\":\"(optional)\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/label/intl/es-ES.json
var $f4728b98a50c812060dd4219685394$exports = {};
$f4728b98a50c812060dd4219685394$exports = JSON.parse("{\"(optional)\":\"(opcional)\",\"(required)\":\"(necesario)\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/label/intl/et-EE.json
var $a195a2ddb77a77ae61ff032a85d661db$exports = {};
$a195a2ddb77a77ae61ff032a85d661db$exports = JSON.parse("{\"(optional)\":\"(valikuline)\",\"(required)\":\"(nõutav)\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/label/intl/fi-FI.json
var $f427dcd1c850040221643be93eb1c6d8$exports = {};
$f427dcd1c850040221643be93eb1c6d8$exports = JSON.parse("{\"(optional)\":\"(valinnainen)\",\"(required)\":\"(pakollinen)\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/label/intl/fr-FR.json
var $de53f4677db63466353789f50a40bfea$exports = {};
$de53f4677db63466353789f50a40bfea$exports = JSON.parse("{\"(optional)\":\"(facultatif)\",\"(required)\":\"(requis)\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/label/intl/he-IL.json
var $ba1fac22eef2511fb370857141$exports = {};
$ba1fac22eef2511fb370857141$exports = JSON.parse("{\"(optional)\":\"(optional)\",\"(required)\":\"(required)\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/label/intl/hr-HR.json
var $ca772e258b44d4e991c3b14e4a1c8e$exports = {};
$ca772e258b44d4e991c3b14e4a1c8e$exports = JSON.parse("{\"(optional)\":\"(opcionalno)\",\"(required)\":\"(obvezno)\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/label/intl/hu-HU.json
var $ed4fe0c134685c30fdd11eefaed4ed5c$exports = {};
$ed4fe0c134685c30fdd11eefaed4ed5c$exports = JSON.parse("{\"(optional)\":\"(opcionális)\",\"(required)\":\"(kötelező)\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/label/intl/it-IT.json
var $b37d70c17e3b737c5e07f1a6e$exports = {};
$b37d70c17e3b737c5e07f1a6e$exports = JSON.parse("{\"(optional)\":\"(facoltativo)\",\"(required)\":\"(obbligatorio)\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/label/intl/ja-JP.json
var $d4248380de973d9c25d85ef71878e2ca$exports = {};
$d4248380de973d9c25d85ef71878e2ca$exports = JSON.parse("{\"(optional)\":\"（オプション）\",\"(required)\":\"（必須）\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/label/intl/ko-KR.json
var $eb4aeb8291c6160038cef4f5ca7ef573$exports = {};
$eb4aeb8291c6160038cef4f5ca7ef573$exports = JSON.parse("{\"(optional)\":\"(선택 사항)\",\"(required)\":\"(필수 사항)\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/label/intl/lt-LT.json
var $b718a314ef2df5e77c257568089e05d$exports = {};
$b718a314ef2df5e77c257568089e05d$exports = JSON.parse("{\"(optional)\":\"(pasirenkama)\",\"(required)\":\"(privaloma)\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/label/intl/lv-LV.json
var $c053703489268122baf00b98caaf$exports = {};
$c053703489268122baf00b98caaf$exports = JSON.parse("{\"(optional)\":\"(neobligāti)\",\"(required)\":\"(obligāti)\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/label/intl/nb-NO.json
var $e2d7e29bd66083fbdcda52c1b7e6dfad$exports = {};
$e2d7e29bd66083fbdcda52c1b7e6dfad$exports = JSON.parse("{\"(optional)\":\"(valgfritt)\",\"(required)\":\"(obligatorisk)\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/label/intl/nl-NL.json
var $abb060a206ac28effe7b5478648b40f$exports = {};
$abb060a206ac28effe7b5478648b40f$exports = JSON.parse("{\"(optional)\":\"(optioneel)\",\"(required)\":\"(vereist)\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/label/intl/pl-PL.json
var $a8c9ddbc73f30cae9576a4d1d816b560$exports = {};
$a8c9ddbc73f30cae9576a4d1d816b560$exports = JSON.parse("{\"(optional)\":\"(opcjonalne)\",\"(required)\":\"(wymagane)\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/label/intl/pt-BR.json
var $fd905eb8181730cb3eed1053b954c5ff$exports = {};
$fd905eb8181730cb3eed1053b954c5ff$exports = JSON.parse("{\"(optional)\":\"(opcional)\",\"(required)\":\"(obrigatório)\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/label/intl/ro-RO.json
var $db7576b1f3c82fac2f8daf16817bc6eb$exports = {};
$db7576b1f3c82fac2f8daf16817bc6eb$exports = JSON.parse("{\"(optional)\":\"(opţional)\",\"(required)\":\"(obligatoriu)\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/label/intl/ru-RU.json
var $ab8f57bf75df135530f40cdde39581$exports = {};
$ab8f57bf75df135530f40cdde39581$exports = JSON.parse("{\"(optional)\":\"(дополнительно)\",\"(required)\":\"(обязательно)\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/label/intl/sk-SK.json
var $fce27b6b1c8cdd182f318ad71cb44e1$exports = {};
$fce27b6b1c8cdd182f318ad71cb44e1$exports = JSON.parse("{\"(optional)\":\"(nepovinné)\",\"(required)\":\"(povinné)\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/label/intl/sl-SI.json
var $c8ceb63a0c31c4f26e970c9e169ec571$exports = {};
$c8ceb63a0c31c4f26e970c9e169ec571$exports = JSON.parse("{\"(optional)\":\"(opcijsko)\",\"(required)\":\"(obvezno)\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/label/intl/sr-SP.json
var $c71f7ad03b0819dc3116807c48caa86$exports = {};
$c71f7ad03b0819dc3116807c48caa86$exports = JSON.parse("{\"(optional)\":\"(opciono)\",\"(required)\":\"(obavezno)\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/label/intl/sv-SE.json
var $edfff34da6733c09360be8100ab7f$exports = {};
$edfff34da6733c09360be8100ab7f$exports = JSON.parse("{\"(optional)\":\"(valfritt)\",\"(required)\":\"(krävs)\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/label/intl/tr-TR.json
var $d92acfd3706c1106f6bdce425b512377$exports = {};
$d92acfd3706c1106f6bdce425b512377$exports = JSON.parse("{\"(optional)\":\"(isteğe bağlı)\",\"(required)\":\"(gerekli)\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/label/intl/uk-UA.json
var $ea5eeab89d6e46c7f46cded12e6300b4$exports = {};
$ea5eeab89d6e46c7f46cded12e6300b4$exports = JSON.parse("{\"(optional)\":\"(необов’язково)\",\"(required)\":\"(обов’язково)\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/label/intl/zh-CN.json
var $c2793089606d14b3ebe166c8ce2f7$exports = {};
$c2793089606d14b3ebe166c8ce2f7$exports = JSON.parse("{\"(optional)\":\"（可选）\",\"(required)\":\"（必填）\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/label/intl/zh-TW.json
var $fd6be8146ee591ee9d870d049bde4333$exports = {};
$fd6be8146ee591ee9d870d049bde4333$exports = JSON.parse("{\"(optional)\":\"(選填)\",\"(required)\":\"(必填)\"}");
// @ts-ignore
const $e5f2e8e117d677abd71f1542812d4fdb$var$intlMessages = {
  "ar-AE": _babelRuntimeHelpersEsmInteropRequireDefault($ad45dfef9011e4c5f6793c02ff0012ba$exports).default,
  "bg-BG": _babelRuntimeHelpersEsmInteropRequireDefault($bc9346d18637648fe979bbfd1a0692b$exports).default,
  "cs-CZ": _babelRuntimeHelpersEsmInteropRequireDefault($cf801b2772a36c48aa537186890ce75$exports).default,
  "da-DK": _babelRuntimeHelpersEsmInteropRequireDefault($f76ee2cdbe534525d5d381f977f1173$exports).default,
  "de-DE": _babelRuntimeHelpersEsmInteropRequireDefault($d30e8bad1c352458524b55d6d74$exports).default,
  "el-GR": _babelRuntimeHelpersEsmInteropRequireDefault($caa3858972ee8679426e788e7789e53b$exports).default,
  "en-US": _babelRuntimeHelpersEsmInteropRequireDefault($d52cb80a7ce3407593566f9943d0acc1$exports).default,
  "es-ES": _babelRuntimeHelpersEsmInteropRequireDefault($f4728b98a50c812060dd4219685394$exports).default,
  "et-EE": _babelRuntimeHelpersEsmInteropRequireDefault($a195a2ddb77a77ae61ff032a85d661db$exports).default,
  "fi-FI": _babelRuntimeHelpersEsmInteropRequireDefault($f427dcd1c850040221643be93eb1c6d8$exports).default,
  "fr-FR": _babelRuntimeHelpersEsmInteropRequireDefault($de53f4677db63466353789f50a40bfea$exports).default,
  "he-IL": _babelRuntimeHelpersEsmInteropRequireDefault($ba1fac22eef2511fb370857141$exports).default,
  "hr-HR": _babelRuntimeHelpersEsmInteropRequireDefault($ca772e258b44d4e991c3b14e4a1c8e$exports).default,
  "hu-HU": _babelRuntimeHelpersEsmInteropRequireDefault($ed4fe0c134685c30fdd11eefaed4ed5c$exports).default,
  "it-IT": _babelRuntimeHelpersEsmInteropRequireDefault($b37d70c17e3b737c5e07f1a6e$exports).default,
  "ja-JP": _babelRuntimeHelpersEsmInteropRequireDefault($d4248380de973d9c25d85ef71878e2ca$exports).default,
  "ko-KR": _babelRuntimeHelpersEsmInteropRequireDefault($eb4aeb8291c6160038cef4f5ca7ef573$exports).default,
  "lt-LT": _babelRuntimeHelpersEsmInteropRequireDefault($b718a314ef2df5e77c257568089e05d$exports).default,
  "lv-LV": _babelRuntimeHelpersEsmInteropRequireDefault($c053703489268122baf00b98caaf$exports).default,
  "nb-NO": _babelRuntimeHelpersEsmInteropRequireDefault($e2d7e29bd66083fbdcda52c1b7e6dfad$exports).default,
  "nl-NL": _babelRuntimeHelpersEsmInteropRequireDefault($abb060a206ac28effe7b5478648b40f$exports).default,
  "pl-PL": _babelRuntimeHelpersEsmInteropRequireDefault($a8c9ddbc73f30cae9576a4d1d816b560$exports).default,
  "pt-BR": _babelRuntimeHelpersEsmInteropRequireDefault($fd905eb8181730cb3eed1053b954c5ff$exports).default,
  "ro-RO": _babelRuntimeHelpersEsmInteropRequireDefault($db7576b1f3c82fac2f8daf16817bc6eb$exports).default,
  "ru-RU": _babelRuntimeHelpersEsmInteropRequireDefault($ab8f57bf75df135530f40cdde39581$exports).default,
  "sk-SK": _babelRuntimeHelpersEsmInteropRequireDefault($fce27b6b1c8cdd182f318ad71cb44e1$exports).default,
  "sl-SI": _babelRuntimeHelpersEsmInteropRequireDefault($c8ceb63a0c31c4f26e970c9e169ec571$exports).default,
  "sr-SP": _babelRuntimeHelpersEsmInteropRequireDefault($c71f7ad03b0819dc3116807c48caa86$exports).default,
  "sv-SE": _babelRuntimeHelpersEsmInteropRequireDefault($edfff34da6733c09360be8100ab7f$exports).default,
  "tr-TR": _babelRuntimeHelpersEsmInteropRequireDefault($d92acfd3706c1106f6bdce425b512377$exports).default,
  "uk-UA": _babelRuntimeHelpersEsmInteropRequireDefault($ea5eeab89d6e46c7f46cded12e6300b4$exports).default,
  "zh-CN": _babelRuntimeHelpersEsmInteropRequireDefault($c2793089606d14b3ebe166c8ce2f7$exports).default,
  "zh-TW": _babelRuntimeHelpersEsmInteropRequireDefault($fd6be8146ee591ee9d870d049bde4333$exports).default
};
var $c9fb1f4220ea2c59cb2e10f0e9828c6e$$interop$default = $parcel$interopDefault($c9fb1f4220ea2c59cb2e10f0e9828c6e$exports);

function $e5f2e8e117d677abd71f1542812d4fdb$var$Label(props, ref) {
  props = useProviderProps(props);

  let {
    children,
    labelPosition = 'top',
    labelAlign = labelPosition === 'side' ? 'start' : null,
    isRequired,
    necessityIndicator = isRequired != null ? 'icon' : null,
    includeNecessityIndicatorInAccessibilityName = false,
    htmlFor,
    for: labelFor,
    elementType: ElementType = 'label',
    onClick
  } = props,
      otherProps = _babelRuntimeHelpersEsmObjectWithoutPropertiesLoose(props, ["children", "labelPosition", "labelAlign", "isRequired", "necessityIndicator", "includeNecessityIndicatorInAccessibilityName", "htmlFor", "for", "elementType", "onClick"]);

  let domRef = useDOMRef(ref);
  let {
    styleProps
  } = useStyleProps(otherProps);
  let formatMessage = useMessageFormatter($e5f2e8e117d677abd71f1542812d4fdb$var$intlMessages);
  let necessityLabel = isRequired ? formatMessage('(required)') : formatMessage('(optional)');

  let icon = /*#__PURE__*/_react.createElement(_spectrumIconsUiAsterisk, {
    UNSAFE_className: classNames($c9fb1f4220ea2c59cb2e10f0e9828c6e$$interop$default, 'spectrum-FieldLabel-requiredIcon'),
    "aria-label": includeNecessityIndicatorInAccessibilityName ? formatMessage('(required)') : undefined
  });

  let labelClassNames = classNames($c9fb1f4220ea2c59cb2e10f0e9828c6e$$interop$default, 'spectrum-FieldLabel', {
    'spectrum-FieldLabel--positionSide': labelPosition === 'side',
    'spectrum-FieldLabel--alignEnd': labelAlign === 'end'
  }, styleProps.className);
  return /*#__PURE__*/_react.createElement(ElementType, _babelRuntimeHelpersEsmExtends({}, filterDOMProps(otherProps), styleProps, {
    onClick: onClick,
    ref: domRef,
    className: labelClassNames,
    htmlFor: ElementType === 'label' ? labelFor || htmlFor : undefined
  }), children, necessityIndicator && ' \u200b', necessityIndicator === 'label' && /*#__PURE__*/_react.createElement("span", {
    "aria-hidden": !includeNecessityIndicatorInAccessibilityName ? isRequired : undefined
  }, necessityLabel), necessityIndicator === 'icon' && isRequired && icon);
}

export let Label = _react.forwardRef($e5f2e8e117d677abd71f1542812d4fdb$var$Label);

function $fbef05647f50ff84b1b0bb6029f8e$var$Field(props, ref) {
  let {
    label,
    labelPosition = 'top',
    labelAlign,
    isRequired,
    necessityIndicator,
    includeNecessityIndicatorInAccessibilityName,
    children,
    labelProps,
    elementType,
    wrapperClassName
  } = props,
      otherProps = _babelRuntimeHelpersEsmObjectWithoutPropertiesLoose(props, ["label", "labelPosition", "labelAlign", "isRequired", "necessityIndicator", "includeNecessityIndicatorInAccessibilityName", "children", "labelProps", "elementType", "wrapperClassName"]);

  let {
    styleProps
  } = useStyleProps(otherProps);

  if (label) {
    let labelWrapperClass = classNames($c9fb1f4220ea2c59cb2e10f0e9828c6e$$interop$default, 'spectrum-Field', {
      'spectrum-Field--positionTop': labelPosition === 'top',
      'spectrum-Field--positionSide': labelPosition === 'side'
    }, styleProps.className, wrapperClassName);
    children = _react.cloneElement(children, mergeProps(children.props, {
      className: classNames($c9fb1f4220ea2c59cb2e10f0e9828c6e$$interop$default, 'spectrum-Field-field')
    }));
    return /*#__PURE__*/_react.createElement("div", _babelRuntimeHelpersEsmExtends({}, styleProps, {
      ref: ref,
      className: labelWrapperClass
    }), /*#__PURE__*/_react.createElement(Label, _babelRuntimeHelpersEsmExtends({}, labelProps, {
      labelPosition: labelPosition,
      labelAlign: labelAlign,
      isRequired: isRequired,
      necessityIndicator: necessityIndicator,
      includeNecessityIndicatorInAccessibilityName: includeNecessityIndicatorInAccessibilityName,
      elementType: elementType
    }), label), children);
  }

  return _react.cloneElement(children, mergeProps(children.props, _babelRuntimeHelpersEsmExtends({}, styleProps, {
    ref
  })));
}

export let Field = _react.forwardRef($fbef05647f50ff84b1b0bb6029f8e$var$Field);
//# sourceMappingURL=module.js.map
